export const configureZoom = (gantt, resourceView) => {
  gantt.config.scale_height = 80;
  gantt.config.static_background = true;
gantt.templates.timeline_cell_class = function(task,date){
    if(date.getDay()==0||date.getDay()==6){
        return "weekend-highlight";
    }
};

var weekScaleTemplate = function (date) {
  var dateToStr = gantt.date.date_to_str("%d %M");
  var endDate = gantt.date.add(gantt.date.add(date, 1, "week"), -1, "day");
  return dateToStr(date) + " - " + dateToStr(endDate);
};

gantt.config.scales = [
  {unit: "week", step: 1, format: weekScaleTemplate},
  {unit: "day", step: 1, format: "%D"}
];
    gantt.ext.zoom.init({
      levels: [
        {
          name: 'day',
          scales: [
            { unit: 'day', step: 1, format: '%d %M' },
            { unit: 'hour', step: 1, format: '%H:%i' },
          ],
          min_column_width: 100,
          scroll_step: 24,
        },
        {
          name: 'week',
          scales: [
            { unit: 'week', step: 1, format: 'Week #%W' },
            { unit: 'day', step: 1, format: '%d %M' },
          ],
          min_column_width: 100,
          scroll_step: 24,
        },
        {
          name: 'month',
          scales: [
            { unit: 'month', step: 1, format: '%F %Y' },
            { unit: 'week', step: 1, format: 'Week #%W' },
          ],
          min_column_width: 100,
          scroll_step: 24,
        },
      ],
    });
  
    gantt.ext.zoom.setLevel(resourceView);
  };
  